import type { Continent } from "../../../lecturas-common/location/continents.model";
import { DataSource } from "./data-source";

export class ContinentsDataSource extends DataSource<Continent>{
    constructor(){
                super("api/continents")
                
    
        }
}